var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{attrs:{"id":"overlay"}},[_c('div',{staticClass:"mx-auto",attrs:{"id":"loader"}},[_c('circle-load',{attrs:{"size":"75px"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }